const LimitText = (str, n, symb) => {
  if (!n && !symb) return str;
  if (str.length <= n) return str;

  const ending = symb || '';
  let newStr = str.slice(0, n);
  const lastSpace = newStr.lastIndexOf(' ');

  if (lastSpace > 0) {
    newStr = newStr.substr(0, lastSpace);
  }

  return newStr + ending;
};

export default LimitText;
